import { render, staticRenderFns } from "./BulkDocTypeUpdate.vue?vue&type=template&id=2a79796c&"
import script from "./BulkDocTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./BulkDocTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports